A profile of a position opening.
